import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'Pnl3BalanceCache';

/**
 * Holds the last-fetched Pnl3 balance summary per asset (sid), keyed as rk. Shared across
 * every open Pnl3Widget instance — same pattern as UserAssetCache/ScenarioAssetCache —
 * so a second window for an asset another window already fetched gets an instant
 * cache-hit while the fresh fetch is in flight.
 */
class Pnl3BalanceCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const pnl3BalanceCache = new Pnl3BalanceCache();
export default pnl3BalanceCache;
